/**
 * Appearance: « Nuit » (docs/design/APP-APPLE.md §2) is the only theme. public/theme-init.js marks the page dark before
 * the first paint; this module keeps it so (an older visit may have stored a light or automatic theme, or an accent
 * color: both are ignored and forgotten, harmlessly). The agent's own color lives on its character now.
 */

const OLD_KEYS = ["pulsez.theme", "pulsez.accent"];

/** On start: dark everywhere, the browser chrome too; the settings of the former theme switch are forgotten. */
export function initTheme(): void {
  const root = document.documentElement;
  root.setAttribute("data-theme", "dark");
  root.removeAttribute("data-accent");
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) meta.setAttribute("content", "#111111");
  try {
    for (const key of OLD_KEYS) localStorage.removeItem(key);
  } catch {
    // Private browsing: nothing stored anyway.
  }
}
